import { useEffect, useState } from 'react'

// Exact complement of Tailwind's `md:` breakpoint (min-width: 768px), so the JS
// boolean and CSS utilities resolve against the identical viewport definition.
const DESKTOP_QUERY = '(min-width: 768px)'

/**
 * True when the viewport is below 768px. matchMedia-based: re-renders only when
 * the breakpoint is crossed, and agrees exactly with Tailwind `md:` utilities.
 */
export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState(() => !window.matchMedia(DESKTOP_QUERY).matches)

  useEffect(() => {
    const mql = window.matchMedia(DESKTOP_QUERY)
    const onChange = (e: MediaQueryListEvent) => setIsMobile(!e.matches)
    mql.addEventListener('change', onChange)
    // Resync in case the viewport changed between first render and effect.
    setIsMobile(!mql.matches)
    return () => mql.removeEventListener('change', onChange)
  }, [])

  return isMobile
}
